import { render, staticRenderFns } from "./AddPaidDocumentModal.vue?vue&type=template&id=2ad87b3e"
import script from "./AddPaidDocumentModal.vue?vue&type=script&lang=js"
export * from "./AddPaidDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad87b3e')) {
      api.createRecord('2ad87b3e', component.options)
    } else {
      api.reload('2ad87b3e', component.options)
    }
    module.hot.accept("./AddPaidDocumentModal.vue?vue&type=template&id=2ad87b3e", function () {
      api.rerender('2ad87b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddPaidDocumentModal.vue"
export default component.exports